import { useQuery } from "@tanstack/react-query";
import api from "../../services/api";

export const useViewMedia = ({ page = 1, limit = 10 } = {}) => {
    return useQuery({
        queryKey: ["viewmedia", page, limit],
        queryFn: async () => {
            const res = await api.get("/media/show", {
                params: { page, limit },
            });
            return res.data;
        },
        keepPreviousData: true,
    });
};